import { useWindowSize } from "react-use";

export const useConfirmModalWidth = () => {
  const { width } = useWindowSize();
  return width > 700 ? 500 : undefined;
};
